import React, { useEffect, useState } from 'react';
import {
  renderDropdownWithoutLabel,
  renderInputFieldWithoutLabel,
} from '../../../../common/inputField';
import { useDispatch, useSelector } from 'react-redux';
import { setEmbryologyData } from '../../../../actions/embryologyActions';
import { TextField } from '@mui/material';
import { toast } from 'sonner';
import {
  cryopreservationDurationRow,
  cryopreservationInitialDataRow,
  cryopreservationThawingDetailsRow,
  emptyBiopsyRow,
  freezingInfoRow,
  freezingLocationRow,
  initialState,
} from '../../../../reducers/embryologyReducer';
import CustomTextField from '../../../../common/CustomTextField';
import DateComponent from '../../../Registrationform/components/dateComponent';
import dayjs from 'dayjs';
import UIModal from '../../../../components/UIElements/UIModal';
import { fetchEmbryologyCryopreservation } from '../../../../api/embryologyApi';

const EmbryoCryopreservation = ({ cycleId, isDisabled }) => {
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    index: null,
  });
  const data = useSelector((state) => state.embryologyReducer);
  const biopsy = useSelector((state) => state.embryologyReducer.biopsy);
  const cryopreservation = useSelector(
    (state) => state.embryologyReducer.cryopreservation,
  );
  const oocyteEmbryo = useSelector(
    (state) => state.embryologyReducer.oocyteEmbryo,
  );

  const rows = [
    cryopreservationInitialDataRow,
    freezingInfoRow,
    freezingLocationRow,
    cryopreservationThawingDetailsRow,
  ];
  const fields = [
    'initialData',
    'freezingInfo',
    'freezingLocation',
    'thawingDetails',
  ];

  const dispatch = useDispatch();
  useEffect(() => {
    let state = {
      initialData: {
        data: [{ ...cryopreservationInitialDataRow }],
      },
      freezingInfo: {
        date: '',
        time: '',
        method: '',
        vitrificationMedia: '',
        sci: '',
        witness: '',
        data: [{ ...freezingInfoRow }],
      },
      freezingLocation: {
        durationOfCryopreservationMonths: '',
        durationOfCryopreservationYears: '',
        expiryDate: '',
        sci: '',
        witness: '',
        data: [{ ...freezingLocationRow }],
      },
      thawingDetails: {
        time: '',
        sci: '',
        witness: '',
        data: [{ ...cryopreservationThawingDetailsRow }],
      },
    };
    const fetchCryopreservation = async () => {
      const response = await fetchEmbryologyCryopreservation(
        data.selectedPatientData.patient.id,
        cycleId,
      );
      if (!response.data.result) {
        return;
      }

      if (response.data.result.oocyteEmbryo) {
        const oocyteEmbryoData = response.data.result.oocyteEmbryo.oocyteEmbryo;
        const day6 = oocyteEmbryoData.day6;
        const strawDataMap = {};
        for (let i = 0; i < day6.data.length; i++) {
          const row = day6.data[i];
          if (row.fate === 'Cryopreserve' || row.fate === 'Embryobiopsy') {
            const currentData = strawDataMap[row.strawNumber];
            if (!currentData) {
              strawDataMap[row.strawNumber] = {
                count: 1,
                day: row.day ? `${row.day}` : '',
                oocyteNumber: `${i + 1}`,
                oocyteCode: row.oocyteEmbryoCode
                  ? `${row.oocyteEmbryoCode}`
                  : '',
                cellNoOrGrade: row.cellNoOrGrade ? `${row.cellNoOrGrade}` : '',
              };
            } else {
              strawDataMap[row.strawNumber].count += 1;
              strawDataMap[row.strawNumber].day += `, ${row.day}`;
              strawDataMap[row.strawNumber].oocyteNumber += `, ${i + 1}`;
              strawDataMap[row.strawNumber].oocyteCode +=
                `, ${row.oocyteEmbryoCode}`;
              strawDataMap[row.strawNumber].cellNoOrGrade +=
                `, ${row.cellNoOrGrade}`;
            }
          }
        }

        const numberOfRows = Object.keys(strawDataMap).length;
        for (let i = 0; i < numberOfRows - 1; i++) {
          for (let i = 0; i < rows.length; i++) {
            const copyState = [...state[fields[i]].data];
            copyState.push({ ...rows[i] });
            state[fields[i]].data = copyState;
          }
        }

        Object.keys(strawDataMap).forEach((key, index) => {
          const value = strawDataMap[key];
          state.initialData.data[index].strawNumber = key;
          state.initialData.data[index].numberOfOocytesOrEmbryos = value.count;
          state.initialData.data[index].day = value.day;
          state.initialData.data[index].oocyteEmbryoNo = value.oocyteNumber;
          state.initialData.data[index].oocyteEmbryoCode = value.oocyteCode;
          state.initialData.data[index].cellNoOrGrade = value.cellNoOrGrade;
        });

        dispatch(setEmbryologyData('cryopreservation', state));
      } else {
        dispatch(
          setEmbryologyData(
            'cryopreservation',
            response.data.result.cryopreservation.cryopreservation,
          ),
        );

        dispatch(
          setEmbryologyData(
            'cryopreservation.id',
            response.data.result.cryopreservation.cryopreservation.id,
          ),
        );
      }
      toast.success('Data fetched');
    };
    fetchCryopreservation();
  }, []);

  const handleInputChange = (e) => {
    if (isDisabled) return;
    const { name, value } = e.target;
    dispatch(setEmbryologyData(`cryopreservation.${name}`, value));
    console.log(name);
    if (
      name === 'freezingLocation.durationOfCryopreservationYears' ||
      name === 'freezingLocation.durationOfCryopreservationMonths'
    ) {
      const updatedValue = value || 0;
      let years =
        name === 'freezingLocation.durationOfCryopreservationYears'
          ? updatedValue
          : cryopreservation.freezingLocation.durationOfCryopreservationYears ||
            0;
      let months =
        name === 'freezingLocation.durationOfCryopreservationMonths'
          ? updatedValue
          : cryopreservation.freezingLocation
              .durationOfCryopreservationMonths || 0;
      years = parseInt(years, 10);
      months = parseInt(months, 10);
      const totalMonths = years * 12 + months;
      const date = new Date();
      date.setMonth(date.getMonth() + totalMonths);
      dispatch(
        setEmbryologyData(
          `cryopreservation.freezingLocation.expiryDate`,
          date.toISOString().split('T')[0],
        ),
      );
    }
  };

  const handleAddRow = () => {
    if (isDisabled) return;
    for (let i = 0; i < rows.length; i++) {
      const copyRows = [...cryopreservation[fields[i]].data];
      copyRows.push({ ...rows[i] });
      dispatch(
        setEmbryologyData(`cryopreservation.${fields[i]}.data`, copyRows),
      );
    }
  };

  const handleRowInputChange = (e, index) => {
    if (isDisabled) return;
    const { name, value } = e.target;
    const section = name.split('.')[0];
    const field = name.split('.')[2];
    const copyRows = [...cryopreservation[section].data];
    copyRows[index][field] = value === ' ' ? '' : value;
    dispatch(setEmbryologyData(`cryopreservation.${section}.data`, copyRows));
  };

  const handleTimeChange = (value, name) => {
    if (isDisabled) return;
    dispatch(setEmbryologyData(`cryopreservation.${name}`, value));
  };

  const handleDeleteRow = (index) => {
    if (isDisabled) return;
    const copyRows = [...biopsy.rows];
    copyRows.splice(index, 1);
    dispatch(setEmbryologyData('biopsy.rows', copyRows));
  };

  const handleDateChange = (day, name, index) => {
    if (isDisabled) return;
    if (index === null || index === undefined) {
      const section = name.split('.')[0];
      const field = name.split('.')[1];
      dispatch(setEmbryologyData(`cryopreservation.${section}.${field}`, day));
    } else {
      const section = name.split('.')[0];
      const field = name.split('.')[2];
      const copyRows = [...cryopreservation[section].data];
      copyRows[index][field] = day;
      dispatch(setEmbryologyData(`cryopreservation.${section}.data`, copyRows));
    }
  };

  return (
    <div className="customer-profile">
      <h3 style={{ textAlign: 'center' }}>Embryo Cryopreservation</h3>

      <div className="body" style={{ display: 'flex' }}>
        <table className="oocyte-embryo-table" style={{ flexGrow: 1 }}>
          <thead>
            <tr>
              <th colSpan={9}>Freezing Info</th>
            </tr>
            <tr>
              <th colSpan={2}>Date:</th>
              <th colSpan={2}>
                <DateComponent
                  id="freezingInfo.date"
                  selectedDate={
                    cryopreservation.freezingInfo.date
                      ? dayjs(cryopreservation.freezingInfo.date)
                      : null
                  }
                  handleDateChange={(date, dateString) =>
                    handleDateChange(date, 'freezingInfo.date')
                  }
                />
              </th>
              <th colSpan={2}>Time:</th>
              <th colSpan={2}>
                <TextField
                  type="time"
                  variant="standard"
                  value={cryopreservation.freezingInfo.time}
                  onChange={(e) =>
                    handleTimeChange(e.target.value, 'freezingInfo.time')
                  }
                />
              </th>
            </tr>
            <tr>
              <th colSpan={2}>Method</th>
              <th colSpan={2} className={'remove-margin-bottom'}>
                {renderDropdownWithoutLabel(
                  'freezingInfo.method',
                  cryopreservation.freezingInfo.method,
                  [' ', 'Slow', 'Vitrification'],
                  handleInputChange,
                )}
              </th>

              <th colSpan={2}>Vitrification Media</th>
              <th colSpan={2}>
                {renderInputFieldWithoutLabel(
                  'freezingInfo.vitrificationMedia',
                  cryopreservation.freezingInfo.vitrificationMedia,
                  handleInputChange,
                )}
              </th>
            </tr>
            <tr>
              <th colSpan={2}>Sci:</th>
              <th colSpan={2}>
                {renderInputFieldWithoutLabel(
                  'freezingInfo.sci',
                  cryopreservation.freezingInfo.sci,
                  handleInputChange,
                )}{' '}
              </th>
              <th colSpan={2}>Witness: </th>
              <th colSpan={2}>
                {renderInputFieldWithoutLabel(
                  'freezingInfo.witness',
                  cryopreservation.freezingInfo.witness,
                  handleInputChange,
                )}{' '}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div style={{ width: '80px' }}>Straw No</div>
              </td>
              <td>
                <div style={{ width: '120px' }}>Oocyte/Embryo No.</div>
              </td>
              <td>
                <div style={{ width: '120px' }}>Oocyte/Embryo Code</div>
              </td>
              <td>
                <div style={{ width: '100px' }}>Day</div>
              </td>
              <td>
                <div>Number of Oocytes/Embryos </div>
              </td>
              <td>
                <div style={{ width: '100px' }}>Cell#/Grade</div>
              </td>
              <td>
                <div style={{ width: '100px' }}>Embryo Status</div>
              </td>
              <td>
                <div style={{ width: '100px' }}>Straw Color</div>
              </td>
            </tr>
            {cryopreservation.initialData.data.map((row, index) => (
              <tr key={index}>
                <td>
                  {renderInputFieldWithoutLabel(
                    `initialData.data[${index}].strawNumber`,
                    row.strawNumber,
                    (e) => handleRowInputChange(e, index),
                  )}
                </td>
                <td>
                  {renderInputFieldWithoutLabel(
                    `initialData.data[${index}].oocyteEmbryoNo`,
                    row.oocyteEmbryoNo,
                    (e) => handleRowInputChange(e, index),
                  )}
                </td>
                <td>
                  {renderInputFieldWithoutLabel(
                    `initialData.data[${index}].oocyteEmbryoCode`,
                    row.oocyteEmbryoCode,
                    (e) => handleRowInputChange(e, index),
                  )}
                </td>
                <td>
                  {renderInputFieldWithoutLabel(
                    `initialData.data[${index}].day`,
                    row.day,
                    (e) => handleRowInputChange(e, index),
                  )}
                </td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={row.numberOfOocytesOrEmbryos}
                    name={`initialData.data[${index}].numberOfOocytesOrEmbryos`}
                    onChange={(e) => handleRowInputChange(e, index)}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
                <td>
                  {renderInputFieldWithoutLabel(
                    `initialData.data[${index}].cellNoOrGrade`,
                    row.cellNoOrGrade,
                    (e) => handleRowInputChange(e, index),
                  )}
                </td>
                <td className={'remove-margin-bottom'}>
                  {renderDropdownWithoutLabel(
                    `freezingInfo.data[${index}].embryoStatus`,
                    cryopreservation.freezingInfo.data[index].embryoStatus,
                    [' ', 'Fresh', 'Refrozen'],
                    (e) => handleRowInputChange(e, index),
                    index,
                  )}
                </td>
                <td>
                  {renderInputFieldWithoutLabel(
                    `freezingInfo.data[${index}].strawColor`,
                    cryopreservation.freezingInfo.data[index].strawColor,
                    (e) => handleRowInputChange(e, index),
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <table className="oocyte-embryo-table" style={{ flexGrow: 1 }}>
          <thead>
            <tr>
              <th colSpan={4}>Freezing Location</th>
            </tr>
            <tr>
              <th colSpan={1}>Cryopreservation Duratrion</th>
              <th colSpan={3}>
                <div className="row-flex">
                  <CustomTextField
                    type="number"
                    label="Years"
                    name={`freezingLocation.durationOfCryopreservationYears`}
                    value={
                      cryopreservation.freezingLocation
                        .durationOfCryopreservationYears
                    }
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    inputProps={{ min: 0 }}
                  />
                  <CustomTextField
                    type="number"
                    label="Months"
                    inputProps={{ min: 0, max: 12 }}
                    name={`freezingLocation.durationOfCryopreservationMonths`}
                    value={
                      cryopreservation.freezingLocation
                        .durationOfCryopreservationMonths
                    }
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                  />
                </div>
              </th>
            </tr>
            <tr>
              <th>Expiry</th>
              <th colSpan={3}>
                <DateComponent
                  id="freezingLocation"
                  selectedDate={
                    cryopreservation.freezingLocation.expiryDate
                      ? dayjs(cryopreservation.freezingLocation.expiryDate)
                      : null
                  }
                  handleDateChange={(date, dateString) =>
                    handleDateChange(date, `freezingLocation.expiryDate`)
                  }
                />
              </th>
            </tr>
            <tr>
              <th colSpan={1}>Sci:</th>
              <th colSpan={1}>
                {renderInputFieldWithoutLabel(
                  'freezingLocation.sci',
                  cryopreservation.freezingLocation.sci,
                  handleInputChange,
                )}{' '}
              </th>

              <th colSpan={1}>Witness: </th>
              <th colSpan={1}>
                {renderInputFieldWithoutLabel(
                  'freezingLocation.witness',
                  cryopreservation.freezingLocation.witness,
                  handleInputChange,
                )}{' '}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div style={{ width: '220px' }}>Tank</div>
              </td>
              <td>
                <div style={{ width: '120px' }}>Canister</div>
              </td>
              <td>
                <div style={{ width: '120px' }}>Viso Color/Cane Number</div>
              </td>
              <td>
                <div style={{ width: '120px' }}>Goblet Color</div>
              </td>
            </tr>
            {cryopreservation.freezingLocation.data.map((row, index) => (
              <tr key={index}>
                <td>
                  {renderInputFieldWithoutLabel(
                    `freezingLocation.data[${index}].tank`,
                    row.tank,
                    (e) => handleRowInputChange(e, index),
                  )}
                </td>
                <td>
                  {renderInputFieldWithoutLabel(
                    `freezingLocation.data[${index}].canister`,
                    row.canister,
                    (e) => handleRowInputChange(e, index),
                  )}
                </td>
                <td>
                  {renderInputFieldWithoutLabel(
                    `freezingLocation.data[${index}].visoColorOrCaneNumber`,
                    row.visoColorOrCaneNumber,
                    (e) => handleRowInputChange(e, index),
                  )}
                </td>
                <td>
                  {renderInputFieldWithoutLabel(
                    `freezingLocation.data[${index}].gobletColor`,
                    row.gobletColor,
                    (e) => handleRowInputChange(e, index),
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <table className="oocyte-embryo-table" style={{ flexGrow: 1 }}>
          <thead>
            <tr>
              <th colSpan={5}>Thawing Details</th>
            </tr>
            <tr>
              <th colSpan={2}>
                <div style={{ height: '40px' }}>Time:</div>
              </th>
              <th colSpan={3}>
                <TextField
                  type="time"
                  variant="standard"
                  value={cryopreservation.thawingDetails.time}
                  onChange={(e) =>
                    handleTimeChange(e.target.value, 'thawingDetails.time')
                  }
                />
              </th>
            </tr>
            <tr>
              <th colSpan={2}>Sci:</th>
              <th colSpan={3}>
                {renderInputFieldWithoutLabel(
                  'thawingDetails.sci',
                  cryopreservation.thawingDetails.sci,
                  handleInputChange,
                )}{' '}
              </th>
            </tr>
            <tr>
              <th colSpan={2}>Witness: </th>
              <th colSpan={3}>
                {renderInputFieldWithoutLabel(
                  'thawingDetails.witness',
                  cryopreservation.thawingDetails.witness,
                  handleInputChange,
                )}{' '}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div style={{ width: '130px' }}>Thawing Date</div>
              </td>
              <td>
                <div>Embryo Transferred?</div>
              </td>
              <td>
                <div style={{ width: '120px' }}>No. Of Embryo Transferred</div>
              </td>
              <td>
                <div style={{ width: '180px' }}>No. of Embryo Refrozen</div>
              </td>
              <td>
                <div style={{ width: '180px' }}>No. of Embryo Discarded</div>
              </td>
            </tr>
            {cryopreservation.thawingDetails.data.map((row, index) => (
              <tr key={index}>
                <td>
                  <DateComponent
                    id={index + 'date'}
                    selectedDate={
                      row.thawingDate ? dayjs(row.thawingDate) : null
                    }
                    handleDateChange={(date, dateString) =>
                      handleDateChange(
                        date,
                        `thawingDetails.data[${index}].thawingDate`,
                        index,
                      )
                    }
                  />
                </td>
                <td className={'remove-margin-bottom'}>
                  {renderDropdownWithoutLabel(
                    `thawingDetails.data[${index}].embryoTransferred`,
                    row.embryoTransferred,
                    [' ', 'Yes', 'No'],
                    (e) => handleRowInputChange(e, index),
                    index,
                  )}
                </td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={row.numberOfEmbryoTransferred}
                    name={`thawingDetails.data[${index}].numberOfEmbryoTransferred`}
                    onChange={(e) => handleRowInputChange(e, index)}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={row.numberOfEmbryoRefrozen}
                    name={`thawingDetails.data[${index}].numberOfEmbryoRefrozen`}
                    onChange={(e) => handleRowInputChange(e, index)}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={row.numberOfEmbryoDiscarded}
                    name={`thawingDetails.data[${index}].numberOfEmbryoDiscarded`}
                    onChange={(e) => handleRowInputChange(e, index)}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <button
        className="btn btn-primary mt-3"
        style={{ width: '200px' }}
        onClick={() => handleAddRow()}
      >
        Add Row
      </button>
      <UIModal
        title="Please confirm?"
        body="Are you sure you want to delete this record?"
        proceedText="Confirm"
        cancelText="Cancel"
        show={confirmModal.open}
        onClose={() => setConfirmModal({ open: false, index: null })}
        onSave={() => {
          handleDeleteRow(confirmModal.index);
          setConfirmModal({ open: false, index: null });
        }}
      />
    </div>
  );
};

export default EmbryoCryopreservation;
